import { useAtom } from 'jotai'
import { SearchFilter } from 'lib/types'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<Array<SearchFilter>>([], MMKVKey.SearchFilters)

export const useSearchFilters = () => useAtom(atom)
export const useResetSearchFilters = () => useAtom(resetAtom)
